import { render } from "./DropdownProducto.vue?vue&type=template&id=e9a34d7c"
import script from "./DropdownProducto.vue?vue&type=script&lang=js"
export * from "./DropdownProducto.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__